import React, { useState } from 'react';
import { Box, ButtonBase, Dialog, Modal, Stack, TextField, Typography } from '@mui/material';
import { isBrowser } from 'react-device-detect';
import { useKioskStore } from '../../../store/kiosk';
import { InputMask, type MaskEventDetail } from '@react-input/mask'
import { NavigateFunction, useNavigate } from 'react-router-dom';
import InputText from '../../../components/InputText';
import InputCallNumber from '../../../components/InputCallNumber';
import { toast } from 'react-toastify';
import { useWindowDimensions } from '../../../App';
import { logger } from '../../../utils/logger';

const CollectCustomer: React.FC = () => {
  const navigate: NavigateFunction = useNavigate();
  const {width} = useWindowDimensions();
  const { openCallName, kioskOrderList, setOpenCallName, setOpenDiningOption, setOpenMyOrder, setKioskOrderList} = useKioskStore();
  const [openDisclaimer, setOpenDisClaimer] = useState(false)
  const [openName, setOpenName] = useState(false)
  const [openCall, setOpenCall] = useState(false)

  const onClickBack = () => {
		// if (!isBrowser) {
		// 	if (window.ReactNativeWebView !== undefined) {
		// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
		// 	} else if(window.Android !== undefined){
		// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
		// 	}
		// }
		setOpenCallName(false)
		setOpenDiningOption(true)
		navigate('/diningoption')
	}

	const hideDialog = () => {
		// if (!isBrowser) {
		// 	if (window.ReactNativeWebView !== undefined) {
		// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
		// 	} else if(window.Android !== undefined){
		// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
		// 	}
		// }
		setOpenCallName(false)
		navigate('/main')
	}


	const onClickEnterName = () => {
		setOpenName(true)
	}

	const onClickCallNumber = () => {
		setOpenCall(true)
	}

	const updateUserName = (val: string) => {
		
		setKioskOrderList({...kioskOrderList, 'customerName': val})
	}


	const updateUserCallNumber = (val: string) => {
		
		setKioskOrderList({...kioskOrderList, 'phoneNo': val})
	}

	const onClickContinue = () => {
		logger.debug(kioskOrderList.phoneNo)
		if(kioskOrderList.phoneNo === '' || kioskOrderList.phoneNo === undefined) {
			toast.error('Please enter your phone number, Phone number is required.')
			return;
		}
		
		// 미국 전화번호 포맷 검증 (XXX)XXX-XXXX
		const phoneRegex = /^\(\d{3}\)\d{3}-\d{4}$/;
		if (!phoneRegex.test(kioskOrderList.phoneNo)) {
			toast.error('Please enter a valid phone number in format (XXX)XXX-XXXX')
			return;
		}
		
		setOpenCallName(false)
		setOpenMyOrder(true)
		navigate('/myorder')
	}

	const onClickSkip = () => {
		setOpenCallName(false)
		setOpenMyOrder(true)
		navigate('/myorder')
	}



  return (
	<>
   	<Dialog open={openCallName} fullScreen>
        <section style={{  
            backgroundImage: `url(${process.env.PUBLIC_URL+'/assets/images/dining_bg.png'})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
			height: '100vh',
			width: '100vw',
			padding: '92px 240px 92px 240px'
        }}>
			<div className="touch-area" style={{position: 'absolute', left: '48px', top: '30px'}} onClick={()=> onClickBack()}>
				<Box>
					<img src={process.env.PUBLIC_URL+'/assets/images/close_s.svg'} width={'56px'} height={'56px'} alt="back" />
					<img src={process.env.PUBLIC_URL+'/assets/images/back_r.svg'} width={'30px'} height={'30px'} alt="back" style={{position: 'absolute', left: '13px', top: '13px'}}/>
				</Box>
			</div>
			<div className="touch-area" style={{position: 'absolute', right: '68px', top: '33px'}} onClick={()=> hideDialog()}>
				<Box>
					<img src={process.env.PUBLIC_URL+'/assets/images/close_bg.svg'} width={'56px'} height={'56px'} alt="back" />
					<img src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'} width={'24px'} height={'24px'} alt="back" style={{position: 'absolute', left: '16px', top: '16px'}}/>
				</Box>
			</div>
            <Stack sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
				<Typography sx={{color: '#000', fontSize: '60px', fontStyle: 'normal', fontWeight: '700', minHeight: '90px'}}>BEFORE YOU CHECK OUT</Typography>
				<Typography sx={{color: '#000', fontSize: '30px', fontStyle: 'normal', fontWeight: '700', mt: '16px', minHeight: '45px'}}>We'll text you when your order is ready.</Typography>
				<Typography sx={{color: '#000', fontSize: '22px', fontStyle: 'normal', fontWeight: '700', width: '497px', minHeight: '66px', textAlign: 'center', lineHeight: '1.2'}}>Also, we'll send exclusive offers and updates if you enter your phone number below.</Typography>
				<Stack sx={{ justifyContent: 'center', alignItems: 'center', width: '582px', height: '381px', padding: '24px 80px', gap: '19px',
							borderRadius: '15px', background: '#fff', boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)', mt: '22px'}}>
				  <TextField 
						sx={{ '& .MuiInputBase-root': {alignItems: 'center', justifyContent: 'center', borderRadius: '10px', border: '1.5px solid #000', background: '#fff', width: '411px', height: '69px', padding: '18px 71px', textAlign: 'center'},
						'& .MuiInputBase-input' : {textAlign: 'center'}}}
						inputProps={{
							readOnly:true,
							style: {
							  fontSize: '22px',
								fontWeight: '500'
							},
						}}
						type="text"
						placeholder='Enter your name' 
						onClick={() =>  onClickEnterName()} 
						value={kioskOrderList!.customerName}/>
				  <InputMask style={{ width: '411px', height: '69px', padding: '18px 71px', textAlign: 'center', borderRadius: '10px', border: '1.5px solid #000', background: '#fff', fontSize: '22px', fontWeight: '500'}}
							mask="(___)___-____"
							placeholder='Enter the phone number*'
							type="tel"
							readOnly
							replacement={{ _: /\d/ }}
							value={kioskOrderList!.phoneNo ?? ''}
							onClick={() => onClickCallNumber()}
							// onMask={(event) => setNumber(event.detail)}
						/>
						<ButtonBase sx={{width: '422px', height: '69px', padding: '4px 33px', borderRadius: '60px', background: '#F72E13'}} onClick={() => onClickContinue()}>
							<Typography sx={{color: '#fff', textAlign: 'center', fontSize: '26px', fontWeight: '700', lineHeight: '150%'}}>Continue</Typography>
						</ButtonBase>
						<ButtonBase sx={{width: '422px', height: '69px', padding: '4px 33px', borderRadius: '60px', background: '#cacaca'}} onClick={() => onClickSkip()}>
							<Typography sx={{color: '#fff', textAlign: 'center', fontSize: '22px', fontWeight: '700', lineHeight: '150%'}}>Skip</Typography>
						</ButtonBase>
				</Stack>
				{/* <Box sx={{display: 'flex', flexDirection: 'row'}}> */}
					<Typography sx={{width: width, px: '20px', minHeight: '57px', flexShrink: 0, fontSize: '12px', fontWeight: '400', color: 'rgba(0, 0, 0, 0.70)' , mt: '22px'}}>By clicking the button above and then signing up via text, you agree to receive recurring automated marketing communications (inc. shopping cart reminders) at the phone number which you use to sign up via text. Message frequency varies. Consent is not a condition of purchase. Reply STOP to unsubscribe. Reply HELP for help. MSG & Data Rates may apply. By signing up via text you agree to the Privacy Policy and Terms and Conditions.  
						<span style={{color: '#000', fontSize: '12px', fontWeight: '500', textDecorationLine: 'underline'}} onClick={() => setOpenDisClaimer(true)}>Read More</span>
					</Typography>
				{/* </Box> */}
			</Stack>
		</section>
	</Dialog>
	<InputText open={openName} text={kioskOrderList!.customerName ?? ''} setOpen={setOpenName} setText={updateUserName} title={"Order Name"}/>
	<InputCallNumber open={openCall} text={kioskOrderList!.phoneNo ?? ''} setOpen={setOpenCall} setText={updateUserCallNumber} title={"Call Number"}/>
	{openDisclaimer? <DisclaimerNotice setOpenDisClaimer={setOpenDisClaimer}/>:<></>}

	</>
  );
}


const DisclaimerNotice = (props: any) => {
		const{ setOpenDisClaimer} = props;
		const hideDialog = () => {
			// if(!isBrowser && window.ReactNativeWebView !== undefined)
			// 	window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
			setOpenDisClaimer(false)
		}
    const rawHTML = `
		<h3>Privacy Policy</h3>
		<small>Last updated: December 06, 2022.</small>
		<small>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</small>
		<small>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the <a href="https://www.termsfeed.com/privacy-policy-generator/" target="_blank">TermsFeed Privacy Policy Generator</a>.</small>
		<h3>Interpretation and Definitions</h3>
		<h4><small>Interpretation</small></h4>
		<small>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</small>
		<h3>Definitions</h3>
		<small>For the purposes of this Privacy Policy:</small>
		<ul>
		<li>
		<small><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</small>
		</li>
		<li>
		<small><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</small>
		</li>
		<li>
		<small><strong>Application</strong> means the software program provided by the Company downloaded by You on any electronic device, named Z ORDER</small>
		</li>
		<li>
		<small><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Z ORDER INC., 3407 W 6TH STREET.</small>
		</li>
		<li>
		<small><strong>Country</strong> refers to: California,  United States</small>
		</li>
		<li>
		<small><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</small>
		</li>
		<li>
		<small><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</small>
		</li>
		<li>
		<small><strong>Service</strong> refers to the Application.</small>
		</li>
		<li>
		<small><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</small>
		</li>
		<li>
		<small><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</small>
		</li>
		<li>
		<small><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</small>
		</li>
		</ul>
		<b><small>Collecting and Using Your Personal Data</small></b>
		<h3>Types of Data Collected</h3>
		<h4>Personal Data</h4>
		<small>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</small>
		<ul>
		<li>
		<small>Email address</small>
		</li>
		<li>
		<small>First name and last name</small>
		</li>
		<li>
		<small>Phone number</small>
		</li>
		<li>
		<small>Usage Data</small>
		</li>
		</ul>
		<h4>Usage Data</h4>
		<small>Usage Data is collected automatically when using the Service.</small>
		<small>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</small>
		<small>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</small>
		<small>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</small>
		<h3>Use of Your Personal Data</h3>
		<small>The Company may use Personal Data for the following purposes:</small>
		<ul>
		<li>
		<small><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</small>
		</li>
		<li>
		<small><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</small>
		</li>
		<li>
		<small><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</small>
		</li>
		<li>
		<small><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</small>
		</li>
		<li>
		<small><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</small>
		</li>
		<li>
		<small><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</small>
		</li>
		<li>
		<small><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</small>
		</li>
		<li>
		<small><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</small>
		</li>
		</ul>
		<small>We may share Your personal information in the following situations:</small>
		<ul>
		<li><small><strong>With Service Providers:</strong></small> We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.</li>
		<li><small><strong>For business transfers:</strong></small> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
		<li><small><strong>With Affiliates:</strong></small> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
		<li><small><strong>With business partners:</strong></small> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
		<li><small><strong>With other users:</strong></small> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
		<li><small><strong>With Your consent</strong></small>: We may disclose Your personal information for any other purpose with Your consent.</li>
		</ul>
		<h3>Retention of Your Personal Data</h3>
		<small>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</small>
		<small>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</small>
		<h3>Transfer of Your Personal Data</h3>
		<small>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</small>
		<small>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</small>
		<small>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</small>
		<h3>Delete Your Personal Data</h3>
		<small>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</small>
		<small>Our Service may give You the ability to delete certain information about You from within the Service.</small>
		<small>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</small>
		<small>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</small>
		<h3>Disclosure of Your Personal Data</h3>
		<h4>Business Transactions</h4>
		<small>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</small>
		<h4>Law enforcement</h4>
		<small>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</small>
		<h4>Other legal requirements</h4>
		<small>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</small>
		<ul>
		<li>Comply with a legal obligation</li>
		<li>Protect and defend the rights or property of the Company</li>
		<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
		<li>Protect the personal safety of Users of the Service or the public</li>
		<li>Protect against legal liability</li>
		</ul>
		<h3>Security of Your Personal Data</h3>
		<small>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</small>
		<b><small>Children's Privacy</small></b>
		<small>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</small>
		<small>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</small>
		<b><small>Links to Other Websites</small></b>
		<small>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</small>
		<small>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</small>
		<b><small>Changes to this Privacy Policy</small></b>
		<small>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</small>
		<small>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</small>
		<small>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</small>
		<b><small>Contact Us</small></b>
		<small>If you have any questions about this Privacy Policy, You can contact us:</small>
		<ul>
		<li><b>By email:</b> info@zorder.net</li>
		</ul>
`
		return(
			<Modal
				keepMounted
				disableScrollLock
				disableEnforceFocus
				// hideBackdrop
				open={true}
				onClose={hideDialog}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={{
					background: 'rgba(0,0,0,0.5)',
					'& .MuiBackdrop-root': {
						backgroundColor: 'transparent'
					}
				}}
			>
				<Box sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '90vw',
					height: '80vh',
					maxWidth: 'none',
					maxHeight: '90vh',
					padding: '40px 25px',
					m: 0,
					display: 'flex',
					flexDirection: 'column',
					borderRadius: '16px',
					background: '#fff',
				}}>
					<Box sx={{ position: 'absolute', right: '28px', top: '13px', zIndex: 2 }} onClick={hideDialog}>
						<img src={process.env.PUBLIC_URL+'/assets/images/close_bg.svg'} width={'40px'} height={'40px'} alt="back" />
						<img src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'} width={'16px'} height={'16px'} alt="back" style={{position: 'absolute', left: '12px', top: '12px'}}/>
					</Box>
					<Box sx={{
						overflow: 'auto',
						overflowX: 'hidden',
						flex: 1,
						mt: '40px'
					}}>
						<div dangerouslySetInnerHTML={{ __html: rawHTML }} />
					</Box>
				</Box>
			</Modal>
		)
}

export default CollectCustomer;
